import {
  Attribute,
  SetTeamAttributeRequest,
} from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const setTeamAttribute = (
  req: Partial<SetTeamAttributeRequest>
): Promise<Attribute> =>
  request({
    url: '/service/userv2service/SetTeamAttribute',
    body: req,
  }).then((r) => r.body);
